
/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

/*Components*/
import SelectBox from '../../components/formComponents/selectBox';
import APILoader from '../../components/other/api-loader';
import NoDataFound from '../../components/other/nothing';

/*Assets*/
import OfferBanner from '../../assets/images/ofr-banner4.jpg';
import OfferLogo from '../../assets/images/purchase-logo.png';
import ViewAdContentModal from '../../components/modals/viewAdContentModal';
import ConfirmationModal from '../../components/modals/confirmationModal';

/*Services*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';


class CreateOffers extends Component {
  constructor(props){
    super(props);
    this.state = {
      apiLoading: false,
      data: null,
      pageNumActive: true,
      pageNumLoader: false,
      pageNum: 1
    }
  }

  componentDidMount() {
    if(localStorage.getItem("vendor_data") && JSON.parse(localStorage.getItem("vendor_data")).seller_type>1){
      this.setState({localVendor: true});
    }
    this.getData(this.state.pageNum);
  }
  getData(tempPageNum){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+'offer/list';
    var data = JSON.stringify({
      "page_num": tempPageNum
    })
    APIPost(url, data).then(function(response){
      if(response.status === "ok"){
        if(response.data.length <= 39){
          this.setState({ pageNumActive: false});
        }
        else{
          this.setState({ pageNumActive: true});
        }

        if(this.state.data){
          var tempData = this.state.data;
          tempData.push(response.data);
          this.setState({ data: data, apiLoading: false, pageNumLoader: false});
        }
        else{
          this.setState({ data: response.data, apiLoading: false, pageNumLoader: false});
        }

      }
      else{
        this.setState({ apiLoading: false });
      }
    }.bind(this))
  }

  loadMore(){
    this.getData(this.state.pageNum + 1);
    this.setState({pageNum: this.state.pageNum + 1, pageNumLoader: true});
  }

  selectChange = async (category) => {
    this.setState({apiLoading: true});
    await this.setState({category: category});
    var url = devconfig.vendor+'offer/list';
    var data = JSON.stringify({
      "page_num": 1,
      "status": category.value,
    })
     APIPost(url,data).then(function(response){
      if(response.status == "ok"){
        this.setState({ data: response.data,apiLoading: false});
      }
    }.bind(this))

  }

  confirmation(id){
    this.setState({id:id})
  }

  render() {

     const filterBy = [
      { value: 1, label: 'Active' },
      { value: 3, label: 'Completed' },
    ]

    return (
      <div>
          <div className="e-main-content e-vendor-table">
            <h2 className="e-page-head">Create Offers</h2>
            {/*<div className="row">
              <div className="col-lg-8">
                <div className="e-create-offer-wrapper">
                  <span>For deals or discounts banner visit "Create ad's" page or <a href="./create-ads">click on this link</a></span>
                </div>
              </div>
            </div>*/}
            <div className="row mt-4 pt-2">
              <div className="col-lg-3">
                <h6 className="e-filter">Filter by</h6>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-6 col-12 e-ofer-select">
                <SelectBox defaultValue={this.state.filterDefault} options={filterBy} selectchange={this.selectChange}/>
              </div>
              <div className="col-lg-9 col-md-6 col-sm-6 col-12">
                <button className="e-s-btn e-new-ofer mt-2" type="submit" value="Submit" data-toggle="modal" data-target="#adDetailModal">Create new offer</button>
              </div>
            </div>

            {
              this.state.apiLoading ?
                <APILoader/>
              :
                <React.Fragment>
                  {
                    this.state.data && this.state.data.length ?
                      <div>
                        <div className="row pt-3">
                          {
                            this.state.data.map((item,index) => {
                              return(
                                <div className="col-lg-9 pb-4">
                                  <div class="card e-vendor-category-list">
                                    <div class="card-header e-create-offer-header">
                                      <div className="row pt-1">
                                        <div className="col-lg-2 col-md-2 col-sm-2 col-6 pr-0">
                                          <h6 className="">Heading:</h6>
                                          <p className="">{item.title}</p>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-6 col-6">
                                          <h6>Starts on:</h6>
                                          <p className="">{item.start_date}</p>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-2 col-6">
                                          <h6>Ends on:</h6>
                                          <p className="">{item.end_date}</p>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-2 col-6">
                                          <h6>Status:</h6>
                                          <p className="e-ongoing">{item.status}</p>
                                        </div>
                                        <div className="col-lg-2 col-m-2 col-sm-2 col-6">
                                          <h6>Category:</h6>
                                          <p className="">{this.state.localVendor? item.department: item.category}</p>
                                        </div>

                                        <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                          <h6>Subcategory:</h6>
                                          {
                                            !this.state.localVendor && item.sub_category_data.map((subCategory,index1) => {
                                               return(
                                                <span className="">{(index1 ? ', ': '') + subCategory.sub_category}</span>
                                              );
                                            })
                                          }
                                          {
                                            this.state.localVendor && item.category_data.map((subCategory,index1) => {
                                               return(
                                                <span className="">{(index1 ? ', ': '') + subCategory.category}</span>
                                              );
                                            })
                                          }
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                          <h6>Items:</h6>
                                          {
                                            !this.state.localVendor && item.product_data.map((subProduct,index2) => {
                                              return(
                                                <span className="">{(index2 ? ', ': '') +subProduct.products}</span>
                                              );
                                            })
                                          }
                                          {
                                            this.state.localVendor && item.sub_category_data.map((subProduct,index2) => {
                                              return(
                                                <span className="">{(index2 ? ', ': '') +subProduct.sub_category}</span>
                                              );
                                            })
                                          }
                                        </div>
                                        <div className="col-lg-3 col-md-11 col-sm-11 col-9">
                                          <h6>Offer:</h6>
                                          <p className="">{item.discount}</p>
                                        </div>
                                        <div className="col-lg-1 col-md-1 col-sm-1 col-1">
                                          <div>
                                            <span className="e-delete-icon" data-toggle="modal" data-target="#confirmModal" onClick={this.confirmation.bind(this,item.id)}></span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          }

                        </div>
                        {
                          this.state.pageNumActive ?
                            <div className="text-center">
                              {
                                this.state.pageNumLoader ?
                                  <APILoader/>
                                :
                                  <button className="e-s-btn-2" onClick={this.loadMore.bind(this)}>Load More</button>
                                }
                              </div>
                            :
                              null
                          }
                        </div>
                      :
                      <NoDataFound data="No offers found. Click button for create new offer"/>
                    }

                </React.Fragment>
            }


            
            {/*Modals*/}
            <ViewAdContentModal getData={this.getData.bind(this)}/>
            <ConfirmationModal id={this.state.id} getData={this.getData.bind(this)}/>

          </div>
       </div>

    );
  }
}

export default CreateOffers;
